import {Component, Inject, OnInit} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {User} from '../../../dtos/user';
import {ValidatorService} from '../../../services/common/validator.service';

export interface DialogData {
  user: User;
}

@Component({
    selector: 'app-edit-profile',
    templateUrl: './edit-profile.component.html',
    styleUrls: ['./edit-profile.component.scss'],
    standalone: false
})
export class EditProfileComponent implements OnInit {

  profileData: UntypedFormGroup;
  currentUser: User;
  submitted: boolean;

  constructor(private _formBuilder: UntypedFormBuilder,
              @Inject(MAT_DIALOG_DATA) public injectedData: DialogData,
              private dialogRef: MatDialogRef<EditProfileComponent>,
              private validatorService: ValidatorService) {
    this.currentUser = injectedData.user;
  }

  ngOnInit(): void {
    this.profileData = this._formBuilder.group({
      firstName: [this.currentUser.firstName, Validators.maxLength(256)],
      lastName: [this.currentUser.lastName, Validators.maxLength(256)],
      country: [this.currentUser.country, Validators.maxLength(256)],
      city: [this.currentUser.city, Validators.maxLength(256)],
      zip: [this.currentUser.zip, this.validatorService.zipCodeValidator],
      street: [this.currentUser.street, Validators.maxLength(256)]
    });
  }

  save(): void {
    this.submitted = true;
    if (this.profileData.valid) {
      const user = new User(
        this.currentUser.id,
        this.profileData.controls.lastName?.value?.trim(),
        this.profileData.controls.firstName?.value?.trim(),
        this.currentUser.email,
        this.currentUser.password,
        this.profileData.controls.street?.value?.trim(),
        this.profileData.controls.zip?.value,
        this.profileData.controls.country?.value,
        this.profileData.controls.city?.value?.trim(),
        null,
        null
      );
      this.dialogRef.close(user);
    }
  }

  cancel(): void {
    this.dialogRef.close(null);
  }

}
